import axios from '../plugins/axios'
import { ref, reactive } from 'vue'
import { showNotif } from '@/core/utility'
import { user, token } from '@/core/auth'

export const listEvent = ref([])
export const myEvents = ref([])
export const eventPeserta = ref([])
export const detailEvent = ref(null)
export const detailBooth = ref([])
export const selectedMyEvent = ref(null)
export const myEventDetail = ref(null)
export const loading = reactive({
  getEvent: false,
  getEventDetail: false,
  getMyEvents: false,
  getPesertaEvent: false,
  getMyEventDetail: false,
  daftarEvent: false
})

export const getEvent = async () => {
  try {
    loading.getEvent = true
    const { data } = await axios.get('event/list')

    if (data.success === true) {
      listEvent.value = data.data
      return {
        status: true,
        message: 'Sukses'
      }
    }

    showNotif({
      status: 'error',
      message: data.message
    })

    return {
      status: false,
      message: data.message
    }
  } catch (error) {
    console.error('Error dari event->getEvent', error)
    let msg = 'Error ambil data event'
    if (error.response?.data?.message) {
      msg = error.response.data.message
    }

    showNotif({
      status: 'error',
      message: msg
    })
    throw error
  } finally {
    loading.getEvent = false
  }
}

export const getPesertaEvent = async () => {
  try {
    loading.getPesertaEvent = true
    const { data } = await axios.get('event/peserta', {
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      eventPeserta.value = data.data
      return {
        status: true,
        message: 'Sukses'
      }
    }

    showNotif({
      status: 'error',
      message: data.message
    })

    return {
      status: false,
      message: data.message
    }
  } catch (error) {
    console.error('Error dari event->getPesertaEvent', error)
    let msg = 'Error ambil data peserta event'
    if (error.response?.data?.message) {
      msg = error.response.data.message
    }

    showNotif({
      status: 'error',
      message: msg
    })
    throw error
  } finally {
    loading.getPesertaEvent = false
  }
}

export const getMyEvents = async (pasId = null) => {
  try {
    loading.getMyEvents = true
    const params = pasId ? { pas_id_periksa: pasId } : {}
    const { data } = await axios.get('event/saya', {
      params,
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      myEvents.value = data.data
      return {
        status: true,
        message: 'Sukses'
      }
    }

    showNotif({
      status: 'error',
      message: data.message
    })

    return {
      status: false,
      message: data.message
    }
  } catch (error) {
    console.error('Error dari event->getMyEvents', error)
    let msg = 'Error ambil data event saya'
    if (error.response?.data?.message) {
      msg = error.response.data.message
    }

    showNotif({
      status: 'error',
      message: msg
    })
    throw error
  } finally {
    loading.getMyEvents = false
  }
}

export const scanKehadiran = async (pasIdPeriksa, kodeScan) => {
  try {
    const { data } = await axios.post('event/scan_kehadiran', {
      pas_id_periksa: pasIdPeriksa,
      kode_scan: kodeScan
    }, {
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      return { status: true, message: data.message, data: data.data }
    }

    showNotif({ status: 'error', message: data.message })
    return { status: false, message: data.message }
  } catch (error) {
    console.error('Error dari event->scanKehadiran', error)
    const msg = error.response?.data?.message || 'Error scan kehadiran'
    showNotif({ status: 'error', message: msg })
    throw error
  }
}

export const scanBooth = async (pasIdPeriksa, kodeScan) => {
  try {
    const { data } = await axios.post('event/scan_booth', {
      pas_id_periksa: pasIdPeriksa,
      kode_scan: kodeScan
    }, {
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      return { status: true, message: data.message, data: data.data }
    }

    showNotif({ status: 'error', message: data.message })
    return { status: false, message: data.message }
  } catch (error) {
    console.error('Error dari event->scanBooth', error)
    const msg = error.response?.data?.message || 'Error scan booth'
    showNotif({ status: 'error', message: msg })
    throw error
  }
}

export const getMyEventDetail = async (haiAcaraId, pasIdPeriksa) => {
  try {
    loading.getMyEventDetail = true
    const { data } = await axios.get('event/aktivitas', {
      params: {
        hai_acara_id: haiAcaraId,
        pas_id_periksa: pasIdPeriksa
      },
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      myEventDetail.value = data.data
      return { status: true, message: 'Sukses' }
    }

    showNotif({ status: 'error', message: data.message })
    return { status: false, message: data.message }
  } catch (error) {
    console.error('Error dari event->getMyEventDetail', error)
    const msg = error.response?.data?.message || 'Error ambil detail event saya'
    showNotif({ status: 'error', message: msg })
    throw error
  } finally {
    loading.getMyEventDetail = false
  }
}

export const daftarEvent = async (haiAcaraId, pasIdPeriksa, kodeUndangan = null) => {
  try {
    loading.daftarEvent = true
    const payload = {
      hai_acara_id: haiAcaraId,
      pas_id_periksa: pasIdPeriksa,
      device: 'WEB'
    }
    if (kodeUndangan) payload.kode_undangan = kodeUndangan
    const { data } = await axios.post('event/daftar', payload, {
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      return { status: true, message: data.message, data: data.data }
    }

    showNotif({ status: 'error', message: data.message })
    return { status: false, message: data.message }
  } catch (error) {
    console.error('Error dari event->daftarEvent', error)
    const msg = error.response?.data?.message || 'Error pendaftaran event'
    showNotif({ status: 'error', message: msg })
    throw error
  } finally {
    loading.daftarEvent = false
  }
}

export const regenerateMidtrans = async (pendaftarId) => {
  try {
    const { data } = await axios.post('event/regenerate_midtrans', {
      pendaftar_id: pendaftarId
    }, {
      headers: {
        id_user: user.value.id,
        token: token.value
      }
    })

    if (data.success === true) {
      return { status: true, data: data.data }
    }

    showNotif({ status: 'error', message: data.message })
    return { status: false }
  } catch (error) {
    console.error('Error dari event->regenerateMidtrans', error)
    const msg = error.response?.data?.message || 'Error regenerate token Midtrans'
    showNotif({ status: 'error', message: msg })
    return { status: false }
  }
}

export const getEventDetail = async (id) => {
  try {
    loading.getEventDetail = true
    const { data } = await axios.get('event/detail', { params: { id } })

    if (data.success === true) {
      detailEvent.value = data.data.acara
      detailBooth.value = data.data.booth || []
      return {
        status: true,
        message: 'Sukses'
      }
    }

    showNotif({
      status: 'error',
      message: data.message
    })

    return {
      status: false,
      message: data.message
    }
  } catch (error) {
    console.error('Error dari event->getEventDetail', error)
    let msg = 'Error ambil detail event'
    if (error.response?.data?.message) {
      msg = error.response.data.message
    }

    showNotif({
      status: 'error',
      message: msg
    })
    throw error
  } finally {
    loading.getEventDetail = false
  }
}
